import React, { useState } from 'react';
import { Card, CardBody, TabContent, TabPane } from 'reactstrap';
import { VENDORS_TABS } from 'pages/Vendor/constants';
import CustomTabs from 'components/CustomTabs';
import VendorBids from './components/VendorBids';
import VendorOrders from './components/VendorOrders';
import MyOffers from './components/MyOffers';
import MyDemands from './components/MyDemands';
import VendorFirebaseData from '../../VendorFirebaseData';
import FavrateGrade from '../VendorFavouriteGrades/FavrateGrade';
import FavrateLocation from '../VendorFavouriteLocation/FavrateLocation';

const VendorDetailTabs = ({ vendorId, vendor, onTimelineRefresh }) => {
  const [activeTab, setActiveTab] = useState(VENDORS_TABS.BIDS);

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const isCompactTab =
    activeTab === VENDORS_TABS.HISTORY ||
    activeTab === VENDORS_TABS.FAVOURITE_GRADE ||
    activeTab === VENDORS_TABS.FAVOURITE_LOCATION;

  return (
    <div>
      <CustomTabs
        className="mb-2"
        tabs={[
          VENDORS_TABS.BIDS,
          VENDORS_TABS.HISTORY,
          VENDORS_TABS.FAVOURITE_GRADE,
          VENDORS_TABS.FAVOURITE_LOCATION,
          VENDORS_TABS.ORDERS,
          VENDORS_TABS.MY_OFFERS,
          VENDORS_TABS.MY_DEMANDS,
        ]}
        selectedTab={activeTab}
        onTabChange={toggle}
      />
      <Card className="border-0 card-box">
        <CardBody className={isCompactTab ? 'pt-0' : ''}>
          <TabContent activeTab={activeTab}>
            <TabPane tabId={VENDORS_TABS.BIDS}>
              {activeTab === VENDORS_TABS.BIDS && <VendorBids />}
            </TabPane>

            <TabPane tabId={VENDORS_TABS.ORDERS}>
              {activeTab === VENDORS_TABS.ORDERS && <VendorOrders />}
            </TabPane>
            <TabPane tabId={VENDORS_TABS.MY_OFFERS}>
              {activeTab === VENDORS_TABS.MY_OFFERS && <MyOffers />}
            </TabPane>
            <TabPane tabId={VENDORS_TABS.MY_DEMANDS}>
              {activeTab === VENDORS_TABS.MY_DEMANDS && <MyDemands />}
            </TabPane>
            <TabPane tabId={VENDORS_TABS.HISTORY}>
              {activeTab === VENDORS_TABS.HISTORY && (
                <VendorFirebaseData
                  vendorId={vendorId}
                  vendor={vendor}
                  embedded
                />
              )}
            </TabPane>
            <TabPane tabId={VENDORS_TABS.FAVOURITE_GRADE}>
              {activeTab === VENDORS_TABS.FAVOURITE_GRADE && (
                <FavrateGrade
                  vendorId={vendorId}
                  embedded
                  onTimelineRefresh={onTimelineRefresh}
                />
              )}
            </TabPane>
            <TabPane tabId={VENDORS_TABS.FAVOURITE_LOCATION}>
              {activeTab === VENDORS_TABS.FAVOURITE_LOCATION && (
                <FavrateLocation vendorId={vendorId} />
              )}
            </TabPane>
          </TabContent>
        </CardBody>
      </Card>
    </div>
  );
};

export default VendorDetailTabs;
